"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DTM_CONSTS = void 0;
/*
eventually these will be refactored to be coming from API.
*/
var DTM_CONSTS = exports.DTM_CONSTS = {
  hero: 'hero',
  readytoapply: 'readytoapply',
  compare: 'compare',
  stickyBanner: 'StickyBanner',
  top: 'top',
  bottom: 'bottom',
  middle: 'middle',
  actionCompare: 'Compare',
  actionSpeakToSpecialist: 'SpeakToSpecialist',
  actionApplyNow: 'ApplyNow',
  actionShowMore: 'Click_ShowMore',
  actionShowLess: 'Click_ShowLess',
  defaultNavType: 'linknav',
  intLinkNavType: 'intlink'
};